import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

import { OnDropdownValueEditedSubject } from './dropdown-editable.model';

@Component({
    selector: 'sha-dropdown-editable',
    templateUrl: './dropdown-editable.component.html',
    styleUrls: ['./dropdown-editable.component.css']
})
export class DropdownEditableComponent implements OnInit {

    @Input() value: number;
    @Input() items: any[];
    @Output() onValueEdited = new EventEmitter<OnDropdownValueEditedSubject>();
    selectedItem: number;
    isDisabled = true;

    constructor() { }

    ngOnInit() {
        this.selectedItem = this.value;
    }

    public keyPressed(event: any) {
        if (event.keyCode === 13) {
            // Enter
            this.saveEdition(event);
        } else if (event.keyCode === 27) {
            // ESC
            this.cancelEdition(event);
        }
    }

    public enableEdition(event: any) {
        this.isDisabled = false;
    }

    public cancelEdition(event: any) {
        this.isDisabled = true;
        this.selectedItem = this.value;
    }

    public saveEdition(event: any) {
        this.isDisabled = true;
        const subject = <OnDropdownValueEditedSubject>{ oldValue: this.value, newValue: this.selectedItem };
        this.onValueEdited.emit(subject);
    }

}




// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/dropdown-editable/dropdown-editable.component.ts